/** The most dots the narrow viewer shows (design a6); a longer list shows the count only. */
export const VIEWER_MAX_DOTS = 7;

/** A swipe shorter than this (px) does not move. */
export const VIEWER_SWIPE_MIN_PX = 48;

/**
 * The next place after a move of `delta` (−1 previous, +1 next). The viewer stops at the ends
 * (design a1: the arrow of an end is off), so the place never wraps.
 */
export function stepIndex(index: number, delta: number, count: number): number {
  if (count <= 0) {
    return 0;
  }
  return Math.min(count - 1, Math.max(0, index + delta));
}

export function canStep(index: number, delta: number, count: number): boolean {
  return stepIndex(index, delta, count) !== index;
}

/** The dots of the narrow viewer: one per item, or null when there are too many (the count shows). */
export function viewerDots(index: number, count: number): boolean[] | null {
  if (count < 2 || count > VIEWER_MAX_DOTS) {
    return null;
  }
  return Array.from({ length: count }, (_, place) => place === index);
}

/**
 * The move of a horizontal swipe: a swipe to the left goes to the next item (+1), to the right to
 * the previous one (−1). A short or mostly vertical swipe does not move (0).
 */
export function swipeDelta(dx: number, dy: number): -1 | 0 | 1 {
  if (Math.abs(dx) < VIEWER_SWIPE_MIN_PX || Math.abs(dx) <= Math.abs(dy)) {
    return 0;
  }
  return dx < 0 ? 1 : -1;
}
